/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Button, Segment } from "semantic-ui-react";
import { TextField } from "@mui/material";
import { globalLoadingOff, globalLoadingOn } from "../slices/globalLoading/globalLoadingSlice";
import { changeBrowserTabTitle } from "../slices/browserTabTitle/browserTabTitleSlice";
import { selectCurrentUserApiToken } from "../slices/currentUser/currentUserSlice";
import { changeEnvironment } from "../slices/environment/environmentSlice";
import { changeTool } from "../slices/footer/footerSlice";
import submitMagicid from "../functions/submitMagicidAPI";
import AlertModal from "./AlertModal";

// eslint-disable-next-line no-empty-pattern
const MAGICtoFEvIRConverterPage = ({ }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const apiToken = useSelector(selectCurrentUserApiToken);

    const [magicEntryState, setMagicEntryState] = useState({ "magicIdInput": "" });
    const [alertModalState, setAlertModalState] = useState({
        open: false, alertHistory: [], header: "", content: ""
    });

    //const [submittingResources, setSubmittingResources] = useState(false);

    const magicSubmitResourcesToProject = async () => {
        let magicIdInput = magicEntryState.magicIdInput.trim();

        if (!magicIdInput) {
            //alert("Please select a MAGIC file to process.");
            setAlertModalState(prevState => {
                return {
                    ...prevState,
                    "open": true,
                    "header": "Error",
                    "content": "Please input a MAGIC Id."
                };
            });
            return;
        }
        dispatch(globalLoadingOn());
        //setSubmittingResources(true);
        try {
            let response = await submitMagicid(magicIdInput, apiToken);
            if (response?.success && response.conversionReportFoiCreated) {
                //dispatch(changeFoiFocus(response.conversionReportFoiCreated));
                navigate(`/resources/Composition/${response.conversionReportFoiCreated}`);
            } else if (response?.success && response.jobAlreadyRunning) {
                setAlertModalState(prevState => {
                    return {
                        ...prevState,
                        "open": true,
                        "header": "Job Currently In Process",
                        "content": response.message
                    };
                });
                if (response.compositionfoi) {
                    navigate(`/resources/Composition/${response.compositionfoi}`);
                }
            } else {
                setAlertModalState(prevState => {
                    return {
                        ...prevState,
                        "open": true,
                        "header": "Error",
                        "content": "Perhaps not a MAGIC JSON file."
                    };
                });
            }
        } catch (e) { console.log(e); }
        //setSubmittingResources(false);
        dispatch(globalLoadingOff());
    };

    const handleKeyUp = (event) => {
        if (event.key === 'Enter') {
            magicSubmitResourcesToProject();
        }
    }

    useEffect(() => {
        dispatch(changeBrowserTabTitle("FEvIR MAGIC-to-FEvIR Converter"));
        dispatch(changeTool("Computable Publishing®: MAGIC-to-FEvIR Converter"));
    }, []);

    return (
        <div>
            <AlertModal alertModalState={alertModalState} setAlertModalState={setAlertModalState} />
            {/*submittingResources &&
                <Dimmer className={"loadingDimmer"} active inverted>
                    <Loader inverted>Submitting</Loader>
                </Dimmer>
            */}
            <Segment className={`containerSegment maxRemainderOfPageSegment`} raised>
                <br />
                {apiToken ?
                    <>
                        <TextField style={{ width: "480px" }} className="inputField" type='text'
                            label={'MAGIC Id'} size="small" variant='outlined'
                            value={magicEntryState.magicIdInput}
                            onKeyUp={handleKeyUp}
                            onChange={(e) => {
                                setMagicEntryState(prevState => {
                                    return { ...prevState, inputChanged: true, magicIdInput: e.target.value };
                                });
                            }} />
                        <br />
                        <br />
                        <Button className="formButton positive"
                            content="Convert MAGIC to FEvIR" compact
                            onClick={() => { magicSubmitResourcesToProject(); }} />
                        <br />
                    </>
                    :
                    <p>Please login. (If you do not have an account click Sign In and log in with your Google Account.)</p>
                }
            </Segment>
        </div>
    );
};

export default MAGICtoFEvIRConverterPage;